module.exports = __webpack_public_path__ + "static/media/logo_home.53729041.png";